import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
import store from "../..";

const state = {
  coursesDomains: [],
  addStatus: false,
  courseDomains: {},
  deleteStatus: false,
  editStatus: false,
};
const getters = {
  coursesDomainsListGet: (state) => state.coursesDomains,
};
const actions = {
  getcoursesDomains({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`courses-domains?page=${page}`).then(
      (obj) => {
        var result = obj.data.courses_domains;
        commit("coursesDomainsListSet", result);
      },
      (error) => {
        console.log("coursesDomains..." + error);
        toastError(error);
      }
    );
  },
  getcourseDomainsById({ commit }, payload) {
    service.getFun(`courses-domains/${payload}`).then(
      (obj) => {
        var result = obj.data.courseDomains;
        commit("courseDomainsById", result);
      },
      (error) => {
        toastError(error);
      }
    );
  },
  addcourseDomains({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `courses-domains/store`,
        null,
        {
          action: "getcoursesDomains",
        }
      )
      .then(
        (result) => {
          console.log(result, "add res");
          result
            ? commit("addcoursesDomainstatus", result.success)
            : commit("aaddcoursesDomainstatus", false);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  editcourseDomains({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `courses-domains/edit/${payload.id}`,
        null,
        {
          action: "getcoursesDomains",
        }
      )
      .then(
        (result) => {
          commit("editcoursesDomainstatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },

  deletecourseDomains({ commit }, payload) {
    service
      .postFun(null, `courses-domains/delete/${payload.payload}`, null, {
        action: "getcoursesDomains",
      })
      .then(
        (result) => {
          commit("deletecoursesDomainstatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },

  // deletecourseDomains({ commit }, payload) {
  //   console.log("payload is", payload);
  //   service
  //     .deleteFun(`courses-domains/delete/${payload.payload}`, null, {
  //       action: "getcoursesDomains",
  //     })
  //     .then(
  //       (result) => {
  //         commit("deletecoursesDomainstatus", result.success);
  //         toast(result.message);
  //       },
  //       (error) => {
  //         toastError(error);
  //       }
  //     );
  // },
};
const mutations = {
  coursesDomainsListSet(state, coursesDomains) {
    state.coursesDomains = coursesDomains;
  },
  addcoursesDomainstatus(state, Status) {
    state.addStatus = Status;
  },
  courseDomainsById(state, employeeReview) {
    state.employeeReview = employeeReview;
  },
  editcoursesDomainstatus(state, Status) {
    state.editStatus = Status;
  },
  deletecoursesDomainstatus(state, Status) {
    state.deleteStatus = Status;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
